import { render } from "./B2bTableMenuFacturas.vue?vue&type=template&id=fc9191f0&scoped=true&lang=pug"
import script from "./B2bTableMenuFacturas.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuFacturas.vue?vue&type=script&lang=js"

import "./B2bTableMenuFacturas.vue?vue&type=style&index=0&id=fc9191f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9191f0"]])

export default __exports__